import React from 'react';
import { useState,useEffect } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import 'react-data-table-component-extensions/dist/index.css';
import DataService from "../../services/tutorial.service";
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import * as AiIcons from "react-icons/ai";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from '../include/Navigationtitle';
import { Image, Shimmer } from 'react-shimmer';
import LoadingOverlay from 'react-loading-overlay-ts';
import { upcomingActlistData } from '../../actions/index';
import { Link } from 'react-router-dom';
import { auctiondefaultLogo } from '../../constants/Images';
import { maxString} from '../../Helpers/Helpers';
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { useMediaQuery } from 'react-responsive'

  function UpcomingAuction(match) {
  
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [isActive, setActive] = useState(false);
    const getpageData = useSelector((state) => state.setupcomingActlistData);  
    const loginuser = useSelector((state) => state.setUserlog); 
    const refresh  = useSelector((state) => state.setRefresh); 
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

     const fetchData = async () => {  
         
      setActive(true); 

      var hdr = {
          headers: {
               'Content-Type': 'application/x-www-form-urlencoded',
               "authorization" : JSON.stringify([{'token':555666777}])
             }
          }
              
      await DataService.upcomingAuction(hdr)
      .then(res => {

          let response = res.data;

            if(response.success==true){

                let responsedata = response.data;
                setData(responsedata);
                dispatch(upcomingActlistData({responsedata}));
              }

           setActive(false); 

          }).catch(()=> { 
          console.log('Not valid')   
          setActive(false); 
        })
    };
    var mystyle={}

    if(!loginuser){
      if (isTabletOrMobile || isPortrait) {
        mystyle = {
          marginLeft: "0"
        }
    
      }
      else {
        mystyle = {
          marginLeft: "-30%"
        }
    
      }
    
    }

    const setauction=(ai,an)=>{  
      localStorage.setItem('auction_id', ai);
      localStorage.setItem('auction_name', an);
     }
     
    
     useEffect(() => {  

      window.scrollTo(0, 0)

      if(getpageData==0){
        fetchData(0);           
        }else{
        setData(getpageData.responsedata);
      }
  }, [refresh]) 
   

  return (
  <>
  <LoadingOverlay
      active={isActive}
      spinner={<BounceLoader color={"#337ab7"} />}
    >
   <div>
   <Navigationtitle data={match} /> 
    <div id="top-categories"style={mystyle} className="top-cat-area default-padding bottom-less">
      <div className="container-fluid">
       <section className="event-area">
         <div className="container-fluid auction-container">

          { data!='' ? 
            
            data.list?.map((getdata,keynew) => {    

              return( <div className="row" key={keynew}>

               { getdata.list?.map((dt) => { 
                
                 return (<div className="event-items">
                  
                    <div className="item vertical col-md-4">
                        <div className="themeact auction-logo">
                        <Image fallback={<Shimmer/>} src={dt.logo=='' ? auctiondefaultLogo : data.path+dt.logo} ></Image>
                        </div>

                        <div className="info">
                            <h4>
                               {maxString(dt.auctionname)}
                               {/* <Link title={dt.auctionname} onClick={()=> setauction(dt.aid, dt.auctionname) } to="/auction-detail">{maxString(dt.auctionname)}</Link> */}
                            </h4>

                            <div className="meta">
                               <ul>
                                 <li> <h5> <AiIcons.AiOutlineCalendar style={{ fontSize:'16px', top:3, position:'relative'}} /> {dt.dt}</h5></li>
                                 <li> <h5 className='auction-code'>, <AiIcons.AiOutlineTeam style={{ fontSize:'17px', top:3, position:'relative'}} /> {dt.player}/Team</h5></li>
                              </ul> 
                            </div>

                          <div className='row'>
                            <div className="col-md-8">
                              <ul className='auction-team-dt auction-team-dt-new'>
                                  <li> POINT : <b className='auction-bold'> {dt.totalpoint} </b></li>
                                </ul>
                            </div>  

                            <div className="col-md-4">
                                {/* {dt.status==1 ? <div className='auction-status inprocess'> INPROCESS </div> : <div className='auction-status pending'> PENDING</div> } */}
                                <a href={'https://superplayerauction.com/view.php?actid='+dt.id} target="_blank">      {<div className='auction-status inprocess'> Detail </div> }</a>
                            </div>   
                          </div>  
                        </div>
                    </div>
                  </div>)})}
                </div>);
               }):  <NotFound data={isActive}/>
              }
          </div>
     </section>
    </div>
 </div>
</div> 
</LoadingOverlay>
</>
  )
}

export default  UpcomingAuction
